import { FormikProps } from 'formik';
import { SuggestedAddress } from '@blocs.address-suggestion';
import { formatBillingPostalCode } from '../Checkout/PaymentForm/formatBillingPostalCode';
import { BillingAddressFields } from './formatters';

// Generic over any Formik values shape that includes the billing-address fields — used both for the
// main payment/add-card form (PaymentMethodFormType) and WalletPicker's own, smaller billing-address
// editor form (BillingAddressFields itself).
export const applySuggestedAddressToFormik = <T extends BillingAddressFields>(
  formik: FormikProps<T>,
  address: SuggestedAddress
): void => {
  const country = address.country || formik.values.country;
  formik.setValues({
    ...formik.values,
    // eslint-disable-next-line camelcase
    address_line_1: address.address1,
    // eslint-disable-next-line camelcase
    address_line_2: address.address2,
    city: address.city,
    // eslint-disable-next-line camelcase
    state_region: address.state,
    // eslint-disable-next-line camelcase
    postal_code: formatBillingPostalCode(address.postalCode, country),
    country,
  });
};
